<template>
      <md-menu md-align-trigger md-size="auto" mdCloseOnSelect>

        <md-field :class="{ 'md-form-group': icon, disabled }" :md-clearable="clearable" md-menu-trigger>
          <md-icon v-if="icon">{{ icon }}</md-icon>
          <label>
            {{ label }}
            <span v-if="required">&nbsp;*</span>
          </label>

          <span v-if="prefix" class="md-prefix">{{ prefix }}</span>
          <md-input :value="internal_value" v-on:input="onInputChange($event)" @keyup.enter="$emit('done', $event)" @click="$emit('click', $event)" type="text" autocomplete="url" :disabled="disabled"> </md-input>
          <span v-if="suffix" class="md-suffix"><small>{{ suffix }}</small></span>
        </md-field>

        <md-menu-content v-show="!disabled" class="extra-wide" v-if="!items">
          <md-menu-item>
            <md-progress-spinner
              :md-diameter="17"
              :md-stroke="2"
              md-mode="indeterminate"
              class="no-fade-out"
              v-if="is_search_in_progress" />
            <div class="md-caption" v-else>
              <span v-if="results.length == 0">Start Typing</span>
              <span v-else-if="results.length == 1">1 Result:</span>
              <span v-else>{{ results.length }} Results:</span>
            </div>
          </md-menu-item>

          <md-menu-item v-for="(item, index) in results" :key="index"
          @click="$emit('select', item, index)">
            <slot :item="item">
              {{ item }}
            </slot>
          </md-menu-item>

        </md-menu-content>
      </md-menu>
</template>

<script>
import utils from '@/components/utils/utils';

export default {
  components: {},
  data(){
    return {
      results: [],
      queryer: null,
      pause_detector: null,
      internal_value: '',
      is_manual_searching: false,
    };
  },
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    prefix: {
      type: String,
      default: ""
    },
    suffix: {
      type: String,
      default: ""
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    searcher: {
      type: Function,
      default: ()=>{}
    },
    minLength: {
      type: [String, Number],
      default: 3
    },
    pauseDelay: {
      type: [String, Number],
      default: 500
    },
    items: {
      type: Array,
      default: () => null,
    },
    manualSearchTrigger: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    value(value){ this.internal_value = value; },
    is_search_in_progress(value){
      this.$emit('update:searching', value);
    }
  },
  computed: {
    is_search_in_progress(){
      if (this.manualSearchTrigger) {
        return this.is_manual_searching;
      }
      return this.queryer && ! this.queryer.hasLastRequestReturned();
    },
  },
  methods:{
    onInputChange(value){
      this.internal_value = value;
      if (!this.manualSearchTrigger) {
        this.queryer.query(value);
        this.pause_detector.touch(value);
      } else {
        // Manual control — call the provided searcher directly
        this.is_manual_searching = true;
        this.searcher(value).then(results => {
          this.results = results;
          this.is_manual_searching = false;
          this.$emit('update:items', results);
        });
      }
      this.$emit('input', value);
    },
    async performSearch(query, id){

      if(query.length < this.minLength){
        this.results = [];
        return;
      }

      try{
        let results = await this.searcher(query, id);

        if(results && this.queryer.isLatestRequest(id)){
          this.results = results;
          this.$emit('update:items', results);
        }

      }catch(error){
        console.error(error);
      }
    },
  },
  created(){
    this.internal_value = this.value;
    if (!this.manualSearchTrigger) {
      // Initialize internal debounced query logic
      this.queryer = new utils.LiveQueryer(this.performSearch);
      this.pause_detector = new utils.TypePauseDetection(
        value => this.queryer.query(value, true),
        this.pauseDelay
      );
    }
  },
};
</script>

<style lang="scss" scoped>
  .disabled{
    opacity: 0.7;
  }
</style>
